import ImageWithScale from './ImageWithScale'

export default ImageWithScale
